<template>
  <el-row>
    <section>
      <div class="flex flex-between">
        <div class="title-bc">{{ $t("m.bean.beanDetailDialog") }}</div>
        <div
          class="title-user"
          v-if="beanDetailInfo.owner != -1 && !isAdd && !notShowUser"
        >
          {{ $t("m.commentDetail.user") }}：{{ beanDetailInfo.owner }}
        </div>
        <div class="line-right">
          <el-button
            type="warning"
            @click="recommendClick(1)"
            v-if="recommend == false && hasAdd == false"
          >
            {{ $t("m.bean.addRecommend") }}
          </el-button>
          <el-button
            type="warning"
            @click="recommendClick(0)"
            v-if="recommend == true && hasAdd == false"
          >
            {{ $t("m.bean.cancelRecommend") }}
          </el-button>
          <el-button
            type="warning"
            v-if="hasAdd == false && !notShowedit"
            @click="saveBeanClick"
            >{{ $t("m.commentDetail.saveChange") }}</el-button
          >
          <el-button
            type="warning"
            v-if="hasAdd == true"
            @click="addBeanClick"
            >{{ $t("m.button.add") }}</el-button
          >
          <el-button
            type="primary"
            v-if="hasAdd == false && !notShowedit"
            @click="beanDeleteClick"
            icon="el-icon-delete"
            class="active-icon"
            >{{ $t("m.commentDetail.delete") }}</el-button
          >
        </div>
      </div>
      <el-form
        ref="beanAddSaveForm"
        :rules="rules"
        :model="beanDetailInfo"
        :disabled="isDisabled"
      >
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 100%">
            <el-form-item prop="stock" style="width: 100%">
              <span class="cus-input-title"
                >{{ $t("m.bean.table.stock") }}{{ weight }}</span
              >
              <el-input
                placeholder=""
                type="text"
                v-model="beanDetailInfo.stock"
              >
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="flex flex-between input-line" style="margin-top:25px;">
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{ $t("m.bean.table.name") }}</span>
            <el-form-item prop="name">
              <el-input
                placeholder=""
                type="text"
                v-model="beanDetailInfo.name"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{ $t("m.bean.table.kind") }}</span>
            <el-form-item prop="kind">
              <el-select
                v-model="beanDetailInfo.kind"
                filterable
                allow-create
                default-first-option
                :placeholder="$t('m.table.select')"
              >
                <el-option
                  v-for="item in beanKindOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="flex flex-between input-line" style="margin-top:25px;">
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{
              $t("m.bean.table.country")
            }}</span>
            <el-form-item prop="country">
              <foreign-area
                @func="countryChange"
                v-model="beanDetailInfo.country"
                :choose-country="beanDetailInfo.country"
                :popular-city="{ value: 'China', label: '中国' }"
              ></foreign-area>
            </el-form-item>
          </div>
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{
              $t("m.bean.table.handleMethod")
            }}</span>
            <el-form-item prop="method">
              <el-select
                v-model="beanDetailInfo.method"
                filterable
                allow-create
                default-first-option
                :placeholder="$t('m.table.select')"
              >
                <el-option
                  v-for="item in methodOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="flex flex-between input-line" style="margin-top:25px;">
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{
              $t("m.bean.table.productArea")
            }}</span>
            <el-form-item prop="area">
              <el-input
                placeholder=""
                type="text"
                v-model="beanDetailInfo.area"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{ $t("m.bean.table.level") }}</span>
            <el-form-item prop="level">
              <el-select
                v-model="beanDetailInfo.level"
                filterable
                allow-create
                default-first-option
                :placeholder="$t('m.table.select')"
              >
                <el-option
                  v-for="item in beanLevelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="flex flex-between input-line" style="margin-top:25px;">
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{ $t("m.bean.table.manor") }}</span>
            <el-form-item prop="manor">
              <el-input
                type="text"
                placeholder=""
                v-model="beanDetailInfo.manor"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">
              {{ $t("m.bean.table.altitude") }}({{ $t("m.bean.table.unit") }})
            </span>
            <el-form-item prop="height">
              <el-input
                placeholder=""
                type="text"
                v-model="beanDetailInfo.height"
              >
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="flex flex-between input-line" style="margin-top:25px;">
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{
              $t("m.bean.table.supplier")
            }}</span>
            <el-form-item prop="supplier">
              <el-input
                placeholder=""
                type="text"
                v-model="beanDetailInfo.supplier"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="flex input-wrap has-title">
            <span class="cus-input-title"
              >{{ $t("m.bean.table.price") }}(¥/kg)</span
            >
            <el-form-item prop="price">
              <el-input
                type="text"
                placeholder=""
                v-model="beanDetailInfo.price"
              >
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="flex flex-between input-line" style="margin-top:25px;">
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{
              $t("m.bean.table.supplierContact")
            }}</span>
            <el-form-item prop="supptel">
              <el-input type="text" v-model="beanDetailInfo.supptel"></el-input>
            </el-form-item>
          </div>
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{
              $t("m.bean.table.buyLink")
            }}</span>
            <el-form-item prop="link">
              <el-input
                type="text"
                placeholder=""
                v-model="beanDetailInfo.link"
              >
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="flex flex-between input-line" style="margin-top:25px;">
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{
              $t("m.bean.table.waterPercent")
            }}</span>
            <el-form-item prop="water">
              <el-input
                placeholder=""
                type="text"
                v-model="beanDetailInfo.water"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="flex input-wrap has-title">
            <span class="cus-input-title">{{ $t("m.bean.table.chanji") }}</span>
            <el-form-item prop="createtime">
              <el-date-picker
                v-model="buydate"
                :picker-options="datePickOptions"
                type="date"
                value-format="timestamp"
                format="yyyy-MM-dd"
                :placeholder="$t('m.table.selectDate')"
                :clearable="false"
                class="dateChange"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </section>
    <section>
      <div class="header-common flex flex-center" style="margin-top: 10px;">
        <span class="header-span header-span-active">{{
          $t("m.chart.chartList")
        }}</span>
      </div>
      <el-table
        v-show="showReportList"
        :data="reportList"
        border
        style="width: 100%"
        :empty-text="$t('m.options.deviceSearchOptions.noData')"
      >
        <el-table-column prop="report.name" :label="$t('m.table.name')">
        </el-table-column>
        <el-table-column
          prop="report.suitVo.suit.hbtime"
          :label="$t('m.table.duration')"
          width="60"
        >
        </el-table-column>
        <el-table-column
          prop="report.createtime"
          :label="$t('m.table.date')"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            {{ $moment(scope.row.report.createtime).format("YYYY-MM-DD") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="report.level"
          :label="$t('m.table.starLevel')"
          width="120"
        >
          <template slot-scope="scope">
            <el-rate
              :colors="['#FC9153', '#FC9153', '#FC9153']"
              v-model="scope.row.report.level"
              disabled
            ></el-rate>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('m.table.operation')"
          width="80"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              style="color: white"
              @click="reportDetailClick(scope.row)"
            >
              {{ $t("m.deviceManage.bindDevice.operation.detail") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        align="right"
        layout="prev, pager, next"
        style="margin-top: 10px"
        :page-size="10000"
        :total="reportPage.total"
      >
      </el-pagination>
    </section>
    <!--------曲线详情---------->
    <el-dialog
      :title="$t('m.deviceManage.bindDevice.operation.detail')"
      :visible.sync="reportDetailDialog"
    >
      <report-chart
        :report-id="selectReportId"
        :key="reportKey"
        :not-showuser="true"
      ></report-chart>
    </el-dialog>
  </el-row>
</template>

<script>
// import report from '@/components/report/report'
//  import commentDetailComponent from "@/components/base/commentDetailComponent";
import foreignArea from "@/components-online/base/foreignArea";
import report from "@/components-online/curve/report";
import { saveAs } from "file-saver";
export default {
  name: "beanDetail",
  props: {
    beanInfo: Object,
    showReportList: Boolean,
    isAdd: Boolean,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    notShowedit: {
      type: Boolean,
      default: false,
    },
    notShowUser: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "report-chart": report,
    foreignArea,
    // 'comment-detail': commentDetailComponent
  },
  data() {
    return {
      weight: "kg",
      beanLevelOptions: [
        { value: "PB", label: "PB" },
        { value: "AA Plus-plus", label: "AA Plus-plus" },
        {
          value: "AA Plus",
          label: "AA Plus",
        },
        { value: "AA", label: "AA" },
        { value: "AB", label: "AB" },
        { value: "C", label: "C" },
        { value: "E", label: "E" },
        { value: "TT", label: "TT" },
        { value: "Grade1", label: "Grade1" },
        { value: "Grade2", label: "Grade2" },
        { value: "Grade3", label: "Grade3" },
        {
          value: "Grade4",
          label: "Grade4",
        },
        { value: "Grade5", label: "Grade5" },
        { value: "Grade6", label: "Grade6" },
        {
          value: "Grade7",
          label: "Grade7",
        },
        { value: "Grade8", label: "Grade8" },
        { value: "Grade9", label: "Grade9" },
        {
          value: "Grade10",
          label: "Grade10",
        },
        { value: "Grade11", label: "Grade11" },
        { value: "Grade12", label: "Grade12" },
        {
          value: "Grade13",
          label: "Grade13",
        },
        { value: "Grade14", label: "Grade14" },
        { value: "Grade15", label: "Grade15" },
        {
          value: "Grade16",
          label: "Grade16",
        },
        { value: "Grade17", label: "Grade17" },
        { value: "Grade18", label: "Grade18" },
        {
          value: "Marago gype",
          label: "Marago gype",
        },
        { value: "Supremo", label: "Supremo" },
        { value: "Excelso", label: "Excelso" },
        {
          value: "UGQ",
          label: "UGQ",
        },
        { value: "GW", label: "GW" },
        { value: "PW", label: "PW" },
        { value: "EPW", label: "EPW" },
        { value: "SH", label: "SH" },
        { value: "HB", label: "HB" },
        { value: "FHB", label: "FHB" },
        { value: "SHB", label: "SHB" },
        { value: "CS", label: "CS" },
        { value: "HG", label: "HG" },
        { value: "SHG", label: "SHG" },
        { value: "Coriente", label: "Coriente" },
        {
          value: "Superior",
          label: "Superior",
        },
        { value: "Caracoil", label: "Caracoil" },
      ],
      beanKindOptions: [
        { value: "铁皮卡", label: "铁皮卡" },
        { value: "波旁", label: "波旁" },
        // { value: "卡图拉", label: "卡图拉" },
        { value: "象豆", label: "象豆" },
        { value: "新世界", label: "新世界" },
        // { value: "卡图埃", label: "卡图埃" },
        { value: "卡蒂莫", label: "卡蒂莫" },
        // { value: "卡斯蒂落", label: "卡斯蒂落" },
        // { value: "帕卡马拉", label: "帕卡马拉" },
        { value: "埃塞俄比亚原生种", label: "埃塞俄比亚原生种" },
        // { value: "提莫混种", label: "提莫混种" },
        { value: "瑰夏", label: "瑰夏" },
        { value: "SL28", label: "SL28" },
        { value: "SL34", label: "SL34" },
        { value: "F1混种", label: "F1混种" },
        { value: "卡杜拉", label: "卡杜拉" },
        { value: "卡杜艾", label: "卡杜艾" },
        { value: "阿拉比卡", label: "阿拉比卡" },
        { value: "罗布斯塔", label: "罗布斯塔" },
        { value: "利比卡", label: "利比卡" },
      ],
      methodOptions: [
        { value: "日晒", label: "日晒" },
        { value: "水洗", label: "水洗" },
        { value: "半水洗", label: "半水洗" },
        { value: "蜜处理", label: "蜜处理" },
        { value: "动物体内发酵", label: "动物体内发酵" },
      ],
      datePickOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      hasAdd: false,
      hasReportList: true,
      beanDetailInfo: {
        name: "",
        area: "",
        country: "",
        height: 0,
        method: "", //处理方式
        kind: "PB", //种类
        level: "铁皮卡", //等级
        link: "",
        manor: "",
        price: 0,
        stock: 0,
        supplier: "",
        supptel: "",
        water: 10,
        userId: 0,
        createtime: new Date(),
        owner: -1,
        buydate: new Date()
      },
      rules: {
        name: [
          {
            required: true,
            message:
              this.$i18n.locale === "en-US"
                ? "Name input error"
                : "名称输入错误",
            trigger: "blur",
          },
        ],
        area: [
          {
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Field input error"
                : "区域输入错误",
            trigger: "blur",
          },
        ],
        supptel: [
          {
            pattern: /^[0-9]*$/,
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "The supplier contact information is incorrect"
                : "供应商联系方式输入错误",
            trigger: "blur",
          },
        ],
        supplier: [
          {
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Supplier input error"
                : "供应商输入错误",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Country entry error"
                : "国家输入错误",
            trigger: "blur",
          },
        ],
        kind: [
          {
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Please select type"
                : "请选择种类",
            trigger: "blur",
          },
        ],
        height: [
          {
            pattern: /^[0-9]*$/,
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Altitude input error"
                : "海拔输入错误",
            trigger: "blur",
          },
        ],
        method: [
          {
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Please enter the process"
                : "请输入处理方式",
            trigger: "blur",
          },
        ],
        manor: [
          {
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Please enter the manor"
                : "请输入庄园",
            trigger: "blur",
          },
        ],
        price: [
          {
            pattern: /^[0-9]*$/,
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Price input error"
                : "价格输入错误",
            trigger: "blur",
          },
        ],
        stock: [
          {
            pattern: /^(-?\d+)(\.\d+)?$/,
            required: true,
            message:
              this.$i18n.locale === "en-US"
                ? "Inventory input must be numeric"
                : "库存输入必须为数字",
            trigger: "blur",
          },
        ],
        water: [
          {
            pattern: /^[0-9]*$/,
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Water content input error"
                : "含水量输入错误",
            trigger: "blur",
          },
        ],
        level: [
          {
            required: false,
            message:
              this.$i18n.locale === "en-US"
                ? "Please select a level"
                : "请选择等级",
            trigger: "blur",
          },
        ],
      },
      recommend: false,
      reportList: [],
      reportPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      detailReport: {
        name: "",
        level: "",
        type: "",
        weight: 0,
        color: "",
        user: {},
        suitVo: {
          bean: {
            name: "",
          },
          lineVoList: [], //曲线数据
          height: 0,
          weight: 0,
        },
      }, //曲线详情
      reportDetailDialog: false,
      selectReportId: 0,
      reportKey: 0,
      selectSuitId: 0,
      reportCommentListDialog: false,
      reportCommentList: [],
      reportCommentPage: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
      },
      selectCommentId: 0,
      refreshCommentDetail: false,
      commentDetailDialog: false,
      buydate: new Date().getTime()
    };
  },
  mounted() {
    this.weight = "(" + localStorage.weight + ")";
    this.hasReportList = this.showReportList;
    this.beanDetailInfo = JSON.parse(JSON.stringify(this.beanInfo));
    console.log(this.beanDetailInfo)
    if (this.isAdd) {
      this.buydate = new Date().getTime();
    } else {
      this.buydate = this.beanDetailInfo.buydate
    }
    console.log(this.buydate)
    this.hasAdd = this.isAdd;
    if (this.hasReportList == true) {
      this.loadReportList();
    }
    // this.checkShared();
    if (localStorage.aqbCofeLang == "en-US") {
      this.beanKindOptions = [
        { value: "Typica", label: "Typica" },
        { value: "Bourbon ", label: "Bourbon " },
        // { value: "卡图拉", label: "卡图拉" },
        { value: "Maragogype", label: "Maragogype" },
        { value: "Mundo Novo", label: "Mundo Novo" },
        // { value: "卡图埃", label: "卡图埃" },
        { value: "Catimo", label: "Catimo" },
        // { value: "卡斯蒂落", label: "卡斯蒂落" },
        // { value: "帕卡马拉", label: "帕卡马拉" },
        { value: "Heirloom", label: "Heirloom" },
        // { value: "提莫混种", label: "提莫混种" },
        { value: "Geisha", label: "Geisha" },
        { value: "SL28", label: "SL28" },
        { value: "SL34", label: "SL34" },
        { value: "F1", label: "F1" },
        { value: "Caturra", label: "Caturra" },
        { value: "Catuai", label: "Catuai" },
        { value: "Arabica", label: "Arabica" },
        { value: "Robusta", label: "Robusta" },
        { value: "Liberica", label: "Liberica" },
      ];
      this.methodOptions = [
        { value: "Nature", label: "Nature" },
        { value: "Washed", label: "Washed" },
        { value: "Semi-washed", label: "Semi-washed" },
        { value: "Honey", label: "Honey" },
        { value: "Fermentation in special", label: "Fermentation in special" },
      ];
    }
  },
  watch: {
    $route(to) {
      console.info("to:" + to);
      this.hasReportList = this.showReportList;
      this.beanDetailInfo = this.beanInfo;
      console.info(this.hasReportList);
      console.info(this.beanDetailInfo);
      if (this.hasReportList == true) {
        this.loadReportList();
      }
    },
    showReportList: function(val) {
      this.hasReportList = val;
      if (val == true) {
        this.loadReportList();
      }
    },
  },
  methods: {
    countryChange(country) {
      this.beanDetailInfo.country = country;
    },
    downLoadReport(report) {
      console.info(report);
      this.$http
        .get("/manage/report/getAReportById.do", {
          params: {
            reportId: report.report.id,
          },
        })
        .then(
          function(resp) {
            let fileName = report.report.name + ".json";
            saveAs(
              new Blob([JSON.stringify(resp.data.data)], {
                type: "",
              }),
              fileName
            );
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    hideCommentDetailDialog() {
      this.commentDetailDialog = false;
      this.refreshCommentDetail = false;
    },
    commentDetailClick(comment) {
      console.info(comment);
      this.selectCommentId = comment.id;
      this.selectSuitId = comment.suitid;
      this.refreshCommentDetail = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshCommentDetail = true;
      });
      this.commentDetailDialog = true;
    },
    getCommentList() {
      this.$http
        .get(
          "/manage/comment/list.do?suitId=" +
            this.selectSuitId +
            "&pageSize=" +
            this.reportCommentPage.pageSize +
            "&pageNum=" +
            this.reportCommentPage.pageNum
        )
        .then(
          function(resp) {
            if (resp.data.success) {
              this.reportCommentList = resp.data.data.list;
              this.reportCommentPage.total = resp.data.data.total;
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    reportCommentListClick() {
      this.reportCommentListDialog = true;
      this.getCommentList();
    },
    recommendClick(recommendVal) {
      this.$confirm(this.$t("m.alert.handle"), this.$t("m.alert.reminder"), {
        confirmButtonText: this.$t("m.alert.confirm"),
        cancelButtonText: this.$t("m.alert.cancel"),
        type: "warning",
      })
        .then(() => {
          let params = new URLSearchParams();
          params.append("beanId", this.beanDetailInfo.id);
          params.append("isOrNot", recommendVal);
          this.$http.post("/manage/bean/pushAReport.do", params).then(
            function(resp) {
              console.info(resp);
              if (resp.data.success) {
                if (recommendVal == 1) {
                  this.$message.success(this.$t("m.alert.updateSuccess"));
                  this.recommend = false;
                } else {
                  this.$message.success(this.$t("m.alert.updateSuccess"));
                  this.recommend = true;
                }
                this.checkShared();
              }
            }.bind(this)
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    checkShared() {
      this.$http
        .get("/manage/bean/checkShared.do", {
          params: { beanId: this.beanDetailInfo.id },
        })
        .then(
          function(resp) {
            console.info(resp);
            this.recommend = resp.data.data;
          }.bind(this)
        );
    },
    loadReportList() {
      this.$http
        .get("/manage/report/getOnlyListByBean.do", {
          params: {
            pageNum: this.reportPage.pageNum,
            pageSize: this.reportPage.pageSize,
            beanId: this.beanDetailInfo.id,
          },
        })
        .then(
          function(resp) {
            this.reportList = resp.data.data.list;
            this.reportPage.total = resp.data.data.total;
            console.info(resp);
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    reportDetailClick(report) {
      console.info(report);
      this.selectReportId = report.report.id;
      this.selectSuitId = report.report.suitid;
      this.$http
        .get("/manage/report/getAReportById.do", {
          params: {
            reportId: report.report.id,
          },
        })
        .then(
          function(resp) {
            this.detailReport = resp.data.data;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
      this.reportDetailDialog = true;
      this.reportKey = this.selectReportId;
    },
    saveBeanClick() {
      /*if (this.beanDetailInfo.stock < 0) {
        this.$message.error("库存数量不能小于0");
        return;
      }*/
      if (this.weight == "(g)") {
        this.beanDetailInfo.stock = this.beanDetailInfo.stock / 1000;
      }
      this.$refs["beanAddSaveForm"].validate((valid) => {
        if (valid) {
          console.info("表单验证通过");
          this.$confirm(
            this.$t("m.alert.saveConfirm"),
            this.$t("m.alert.reminder"),
            {
              confirmButtonText: this.$t("m.alert.confirm"),
              cancelButtonText: this.$t("m.alert.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              let params = new URLSearchParams();

              params.append("name", this.beanDetailInfo.name);
              params.append("stock", this.beanDetailInfo.stock);
              params.append("id", this.beanDetailInfo.id);
              params.append("userId", localStorage.getItem("userid"));
              if (this.beanDetailInfo.country!=undefined) {
                params.append("country", this.beanDetailInfo.country);
              }
              if (this.beanDetailInfo.area!=undefined) {
                params.append("area", this.beanDetailInfo.area);
              }
              if (this.beanDetailInfo.manor!=undefined) {
                params.append("manor", this.beanDetailInfo.manor);
              }
              if (this.beanDetailInfo.kind!=undefined) {
                params.append("kind", this.beanDetailInfo.kind);
              }
              if (this.beanDetailInfo.level!=undefined) {
                params.append("level", this.beanDetailInfo.level);
              }
              if (this.beanDetailInfo.method!=undefined) {
                params.append("method", this.beanDetailInfo.method);
              }
              if (this.beanDetailInfo.height!=undefined) {
                params.append("height", this.beanDetailInfo.height);
              }
              if (this.beanDetailInfo.water!=undefined) {
                params.append("water", this.beanDetailInfo.water);
              }
              if (this.beanDetailInfo.supplier!=undefined) {
                params.append("supplier", this.beanDetailInfo.supplier);
              }
              if (this.beanDetailInfo.supptel!=undefined) {
                params.append("supptel", this.beanDetailInfo.supptel);
              }
              if (this.beanDetailInfo.link!=undefined) {
                params.append("link", this.beanDetailInfo.link);
              }
              if (this.beanDetailInfo.price!=undefined) {
                params.append("price", this.beanDetailInfo.price);
              }
              if (this.buydate!=undefined) {
                this.beanDetailInfo.buydate = this.buydate;
                params.append("buydate",
                    this.$moment(this.buydate).format("YYYY-MM-DD"));
              }
              this.$http
                .post("/manage/bean/update.do", params)
                .then(
                  function(resp) {
                    if (resp.data.success) {
                      this.$message.success(this.$t("m.alert.updateSuccess"));
                      this.$router.go(0);
                    } else {
                      this.$message.error(this.$t("m.alert.updateError"));
                    }
                  }.bind(this)
                )
                .catch((err) => {
                  console.info(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("m.alert.canceled"),
              });
            });
        } else {
          console.info("表单验证失败" + valid);
        }
      });
    },
    addBeanClick() {
      if (this.beanDetailInfo.stock < 0) {
        this.$message.error("库存数量不能小于0");
        return;
      }
      if (this.weight == "(g)") {
        this.beanDetailInfo.stock = this.beanDetailInfo.stock / 1000;
      }
      this.$refs["beanAddSaveForm"].validate((valid) => {
        if (valid) {
          console.info("表单验证通过");
          this.$confirm(
            this.$t("m.alert.addConfirm"),
            this.$t("m.alert.reminder"),
            {
              confirmButtonText: this.$t("m.alert.confirm"),
              cancelButtonText: this.$t("m.alert.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              let params = new URLSearchParams();
              params.append("name", this.beanDetailInfo.name);
              params.append("stock", this.beanDetailInfo.stock);
              params.append("userId", localStorage.getItem("userid"));
              console.log(localStorage.getItem("userid"))
              if (this.beanDetailInfo.country!=undefined) {
                params.append("country", this.beanDetailInfo.country);
              }
              if (this.beanDetailInfo.area!=undefined) {
                params.append("area", this.beanDetailInfo.area);
              }
              if (this.beanDetailInfo.manor!=undefined) {
                params.append("manor", this.beanDetailInfo.manor);
              }
              if (this.beanDetailInfo.kind!=undefined) {
                params.append("kind", this.beanDetailInfo.kind);
              }
              if (this.beanDetailInfo.level!=undefined) {
                params.append("level", this.beanDetailInfo.level);
              }
              if (this.beanDetailInfo.method!=undefined) {
                params.append("method", this.beanDetailInfo.method);
              }
              if (this.beanDetailInfo.height!=undefined) {
                params.append("height", this.beanDetailInfo.height);
              }
              if (this.beanDetailInfo.water!=undefined) {
                params.append("water", this.beanDetailInfo.water);
              }
              if (this.beanDetailInfo.supplier!=undefined) {
                params.append("supplier", this.beanDetailInfo.supplier);
              }
              if (this.beanDetailInfo.supptel!=undefined) {
                params.append("supptel", this.beanDetailInfo.supptel);
              }
              if (this.beanDetailInfo.link!=undefined) {
                params.append("link", this.beanDetailInfo.link);
              }
              if (this.beanDetailInfo.price!=undefined) {
                params.append("price", this.beanDetailInfo.price);
              }
              if (this.buydate!=undefined) {
                // params.append("buydate", this.beanDetailInfo.buydate);
                this.beanDetailInfo.buydate = this.buydate;
                params.append("buydate",
                this.$moment(this.beanDetailInfo.buydate).format("YYYY-MM-DD"));
              }
              this.$http
                .post("/manage/bean/add.do", params)
                .then(
                  function(resp) {
                    if (resp.data.success) {
                      this.$message.success(this.$t("m.alert.addSuccess"));
                      this.$router.go(0);
                    } else {
                      this.$message.error(this.$t("m.alert.addError"));
                    }
                  }.bind(this)
                )
                .catch((err) => {
                  console.info(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("m.alert.canceled"),
              });
            });
        }
      });
    },
    beanDeleteClick() {
      let ids = new Array();
      ids.push(this.beanDetailInfo.id);
      this.deleteBatch(ids);
    },
    deleteBatch(ids) {
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let params = new URLSearchParams();
          params.append("ids", ids);
          this.$http.post("/manage/bean/updatePatch.do", params).then(
            function(resp) {
              if (resp.data.success) {
                this.$message.success(this.$t("m.alert.deleteSuccess"));
                this.$router.go(0);
              }
            }.bind(this)
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.cancelDelete"),
          });
        });
    },
  },
};
</script>

<style scoped>
.input-line > div {
  flex: 1;
}

.input-line > div > .el-form-item {
  margin-bottom: 0;
}

.input-line > div:first-child > .el-form-item {
  width: 95%;
}

.input-line > div:last-child > .el-form-item {
  width: 95%;
  margin-left: 5%;
}

.input-line > div:last-child:not(:only-child).has-title .cus-input-title {
  left: calc(5% + 15px);
}

.input-line > div:only-child > .el-form-item {
  width: 100%;
  margin-left: 0;
}

.input-line > div > .el-form-item >>> .el-select {
  width: 100%;
}
::v-deep .has-title .el-date-editor .el-input__suffix {
  height: 40px !important;
  line-height: 45px!important;
}
</style>
